import { render, staticRenderFns } from "./translate.vue?vue&type=template&id=81c840ce&scoped=true"
import script from "./translate.vue?vue&type=script&lang=js"
export * from "./translate.vue?vue&type=script&lang=js"
import style0 from "./translate.vue?vue&type=style&index=0&id=81c840ce&prod&scoped=true&lang=css"
import style1 from "./translate.vue?vue&type=style&index=1&id=81c840ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c840ce",
  null
  
)

export default component.exports